import { React } from "react";
import image from "../assets/anant-bg.jpg"
import video from "../assets/anant-bg.mp4"

export default function Home() {
    const mediaUrl = window.innerWidth >= 650 ? video : image;
    console.log(window.innerWidth)
    console.log(mediaUrl)

    return (
        <main>
            <img src={image} alt="Anant Background" className="absolute object-fill w-screen h-screen md:hidden lg:hidden" />
            <video id="bg-video"  className='absolute object-fill w-screen h-screen opacity-50 bg-scroll' autoPlay loop muted>
                <source src={video} type='video/mp4' />
            </video>
            <section className="relative flex justify-center h-auto pt-32 lg:pt-64 px-8">
                <h2 className="sm:text-4xl md:text-6xl lg:text-8xl text-gray-200 lg:text-gray-800 font-bold cursive leading-none lg:leading-snug">
                    Welcome to Infinity!
                </h2>
            </section>
        </main>
    )
}